module.exports = __webpack_public_path__ + "static/img/mens_test_1.7a78e49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_test_1.svg
// module id = 5s/9
// module chunks = 0